import React from 'react';
import { getRowSpan, getColSpan, is, und } from '../Utils';

export const TableRow = ({ row, ...props }) => <tr {...props} />;

export const TableCell = ({ row, dataIndex, ...props }) => <td {...props} />;

export const NestedColumnAlgorithm = (props) => {
	const { component: Column, columns, source, nested = '' } = props;
	const rowSpan = getRowSpan(columns);
	const descendants = columns.reduce((result, { columns: nestedColumns }) => {
		return nestedColumns ? [...result, ...nestedColumns] : result;
	}, []);
	return (
		<>
			<tr>
				{columns.map(
					({ label: Label, dataIndex, columns: nestedColumns }, index) => (
						<Column
							key={(dataIndex || 0) + index}
							label={is.str(Label) ? Label : <Label data={source} />}
							dataIndex={dataIndex}
							data-reatable={
								nestedColumns ? 'column-group' + nested : 'column' + nested
							}
							colSpan={nestedColumns ? getColSpan(nestedColumns) : und}
							rowSpan={nestedColumns || rowSpan === 1 ? und : rowSpan}
						/>
					)
				)}
			</tr>
			{!!descendants.length && (
				<NestedColumnAlgorithm
					{...{ ...props, columns: descendants, nested: '-nested' }}
				/>
			)}
		</>
	);
};

export const NestedCellAlgorithm = (props) => {
	const { component: Cell, columns, row, index, actions } = props;
	return columns
		.map(
			(
				{
					dataIndex,
					render,
					columns: nestedColumns,
					label,
					cellAttr,
					mountCellWhen,
				},
				index
			) => {
				const mountCellWhenIsFnc = is.fnc(mountCellWhen);
				return nestedColumns ? (
					<NestedCellAlgorithm
						key={dataIndex || label}
						{...{ ...props, columns: nestedColumns }}
					/>
				) : (
					((mountCellWhenIsFnc && mountCellWhen(row, index, actions)) ||
						!mountCellWhenIsFnc) && (
						<Cell
							key={dataIndex + index}
							dataIndex={dataIndex}
							row={row}
							data-sorted={actions.sort.orderBy === dataIndex || und}
							{...(is.fnc(cellAttr) && cellAttr(row, index, actions))}>
							{is.fnc(render)
								? render(row[dataIndex], row, index, actions)
								: row[dataIndex]}
						</Cell>
					)
				);
			}
		)
		.flat();
};
